class GreensaversQuiz {
  constructor() {
    // Constants
    this.STORAGE_KEY = 'greensavers_quiz_data';
    this.API_URLS = {
      propertyInfo: 'https://us-central1-greensavers-732dc.cloudfunctions.net/getPropertyInfo',
      workatoWebhook: 'https://webhooks.workato.com/webhooks/rest/c98326ef-db2c-45b3-a483-c45e8c4c6cae/new_quiz',
      // createLead: 'https://createinsightlylead-pbhvynrpfq-uc.a.run.app',
      // updateLead: 'https://updateinsightlylead-pbhvynrpfq-uc.a.run.app'
    };

    // @ts-ignore
    this.quizConfig = window.gsQuizConfig || {};

    // Electricity provider names
    this.ELECTRICITY_PROVIDER_NAMES = {
      'pge': 'PGE',
      'pacific-power': 'PacPower',
      'central-electric-co-op': 'CEC',
      'midstate-electric-co-op': 'Midstate',
    };
    
    // Gas provider names
    this.GAS_PROVIDER_NAMES = {
      'northwest-natural-gas': 'NWN',
      'cascade-natural-gas': 'Cascade',
      'none': 'None',
    };
    // System type labels
    this.SYSTEM_TYPE_LABELS = {
      1: 'Single',
      2: 'Dual',
      3: 'Tri',
      4: 'Quad'
    };

    this.BUTTON_DYNAMIC_LABELS = {
      'duct-system': 'with Existing Duct System',
      'ductless': 'with Ductless',
      'quilt': 'with Quilt',
      'mitsubishi': 'with Mitsubishi',
      '50-gallon': 'with 50 Gallon',
      '65-gallon': 'with 65 Gallon',
      'other': 'with Other',
      'tankless': 'with Tankless',
      'traditional-tank': 'with Traditional Tank',
      'electric-water-heater': 'with Electric Water Heater',
      'gas-water-heater': ' with Gas Water Heater',
      'heat-pump-water-heater': 'with Heat Pump Water Heater',
    };

    // DOM Elements - Steps
    this.steps = document.querySelectorAll('.step');
    this.stepContents = document.querySelectorAll('[data-step-content]');
    this.consultationOptions = document.querySelectorAll('[data-consultation-option]');
    this.backButtons = document.querySelectorAll('[data-back-step]');
    this.startOverButtons = document.querySelectorAll('[data-start-over]');
    this.textInputElements = document.querySelectorAll('.gs-input');
    this.inputOptions = document.querySelectorAll('.gs-option__input');
    this.continueButtons = document.querySelectorAll('[data-continue-step]');
    this.quizProgressBars = document.querySelectorAll('.quiz-progress-bar-fill');
    this.quizImages = document.querySelectorAll('.quiz-image');
    this.quizImagesContainer = document.querySelector('.quiz-images');

    // Mapbox address autocomplete
    this.MAPBOX_TOKEN = 'pk.eyJ1IjoiZ3JlZW5zYXZlcnMiLCJhIjoiY21vYTdnZjU5MDN5OTJwcHdlc2MxZ3IwNSJ9.3eT0WpXqdPD8mXcL2SUArA';
    this.MAPBOX_SEARCH_BASE = 'https://api.mapbox.com/autofill/v1';
    this.mapboxSessionToken = null;
    this.autocompletePanel = null;
    this.autocompleteActiveIndex = -1;
    this.autocompleteDebounceTimer = null;
    this.autocompleteSelected = false;

    // Step 1 - Property Information
    this.findPropertyButton = document.getElementById('find-property-button');
    this.propertyInformationForm = document.querySelector('.property-information-form');
    this.confirmPropertyInformation = document.querySelector('.confirm-property-information');
    this.confirmPropertyInformationButton = document.getElementById('confirm-property-information-button');
    this.editPropertyInformationButton = document.getElementById('edit-property-information-button');
    this.editPropertyInformationSection = document.querySelector('.edit-property-information');
    this.savePropertyInformationButton = document.getElementById('save-property-information-button');
    this.cancelEditPropertyButton = document.getElementById('cancel-edit-property-button');
    this.propertyAddressElement = document.querySelectorAll('[data-property-address]');
    this.propertyInformationElement = document.querySelectorAll('[data-property-information]');
    this.propertHeatingElement = document.querySelectorAll('[data-property-heating]');
    this.propertyCoolingElement = document.querySelectorAll('[data-property-cooling]');
    this.editHeatingButtons = document.querySelectorAll('[data-edit-heating]');
    this.editCoolingButtons = document.querySelectorAll('[data-edit-cooling]');
    this.editHeatingWrappers = document.querySelectorAll('[data-edit-heating-wrapper]');
    this.editCoolingWrappers = document.querySelectorAll('[data-edit-cooling-wrapper]');

    // Step 4 - Room Configuration
    this.roomTypesContainer = document.querySelector('.room-types');
    this.roomTypes = document.querySelectorAll('.room-type');
    this.roomTypeSelects = document.querySelectorAll('.room-type-select');
    this.roomTypeOptions = [
      { id: 'bedroom', name: 'Bedroom' },
      { id: 'living-room', name: 'Living Room' },
      { id: 'kitchen', name: 'Kitchen' },
      { id: 'dining-room', name: 'Dining Room' },
      { id: 'family-room', name: 'Family Room' },
      { id: 'office', name: 'Office/Study' },
      { id: 'basement', name: 'Basement' },
      { id: 'guest-room', name: 'Guest Room' },
      { id: 'master-bedroom', name: 'Master Bedroom' },
      { id: 'den', name: 'Den' },
      { id: 'sunroom', name: 'Sunroom' },
      { id: 'adu', name: 'ADU (Accessory Dwelling Unit)' }
    ];

    // Step 99 - Final Step
    this.productTitleElement = document.getElementById('product-title');
    this.productTitleLinkElement = document.getElementById('product-title-link');
    this.productDescriptionElement = document.getElementById('product-description');
    this.productPriceElement = document.getElementById('product-price');
    this.subtotalValueElement = document.getElementById('subtotal-value');
    this.dueTodayValueElement = document.getElementById('due-today-value');
    this.dueTodayPercentageElement = document.getElementById('due-today-percentage');
    this.planDiscountValueElement = document.getElementById('plan-discount-value');
    this.productVariantIdInput = document.getElementById('product-variant-id');
    this.productSellingPlanIdInput = document.getElementById('product-selling-plan-id');
    this.quizCartForm = document.getElementById('quiz-cart-form');
    this.leadEmailPropertiesInput = document.getElementById('lead-email-properties-input');
    this.leadEmailAttributesInput = document.getElementById('lead-email-attributes-input');
    this.addToCartButton = document.getElementById('add-to-cart-button');
    this.goToProductButton = document.getElementById('go-to-product-button');
    this.providerDiscountLabelElement = document.getElementById('provider-discount-label');
    this.providerDiscountValueElement = document.getElementById('provider-discount-value');
    this.incentivePropertiesInput = document.getElementById('incentive-properties-input');
    this.incentiveRow = document.getElementById('incentive-row');

    // Incentive lookup table
    // Key format: "service|propertyType|provider|heatingFuel"
    this.INCENTIVE_TABLE = {
      // Ductless Heat Pump (Quilt and Mitsubishi)
      'heat-pump|Single Family|pge|Electric': 1000,
      'heat-pump|Manufactured|pge|Electric': 1000,
      'heat-pump|Single Family|pacific-power|Electric': 800,
      'heat-pump|Manufactured|pacific-power|Electric': 1000,

      // Navien Tankless Water Heater - Northwest Natural Gas
      'water-heater|Single Family|northwest-natural-gas|Gas': 400,
      'water-heater|Manufactured|northwest-natural-gas|Gas': 400,
      'water-heater|Townhouse, Duplex, Triplex, Fourplex|northwest-natural-gas|Gas': 400,
      'water-heater|Townhouse|northwest-natural-gas|Gas': 400,
      'water-heater|Multi-Family|northwest-natural-gas|Gas': 400,

      // Navien Tankless Water Heater - Cascade Natural Gas
      'water-heater|Single Family|cascade-natural-gas|Gas': 400,
      'water-heater|Manufactured|cascade-natural-gas|Gas': 400,
      'water-heater|Townhouse, Duplex, Triplex, Fourplex|cascade-natural-gas|Gas': 400,
      'water-heater|Townhouse|cascade-natural-gas|Gas': 400,
      'water-heater|Multi-Family|cascade-natural-gas|Gas': 400,
    };

    // Back button
    this.quizBackButton = document.querySelector('.quiz-back-button');

    // Loader
    this.loader = document.querySelector('.loader');
    this.loaderText = document.querySelector('.loader__text');
    this.loaderDescription = document.querySelector('.loader__description');

    // Default quiz state
    this.defaultQuizData = {
      currentStep: 1,
      stepHistory: [1],
      confirmPropertyInformation: false,
      emailAddress: null,
      firstName: null,
      lastName: null,
      phoneNumber: null,
      propertyAddress: null,
      propertyInformation: null,
      service: null,
      ductType: null,
      rooms: null,
      roomTypes: {
        'room-1': 'bedroom',
        'room-2': 'living-room',
        'room-3': 'kitchen',
        'room-4': 'dining-room',
      },
      system: null,
      product: null,
      productVariant: null,
      leadSubmitted: false,
      // leadId: null,
      // leadSourceId: null,
      // leadStatusId: null,
      createdAt: new Date().toISOString(),
      lastModified: new Date().toISOString(),
      tankType: null,
      tankSize: null,
      tankFuel: null,
      providerElectricity: null,
      providerGas: null,
    };

    // Initialize or restore quiz data
    this.quizData = this.loadQuizData() || { ...this.defaultQuizData };
  }

  get systemTypeLabel() {
    const rooms = +this.quizData.rooms;
    return this.SYSTEM_TYPE_LABELS[/** @type {1|2|3|4} */ (rooms)] || '';
  }

  get selectedRoomsText() {
    return Object.values(this.quizData.roomTypes).map(type => {
      const option = this.roomTypeOptions.find(option => option.id === type);
      return option ? option.name : '';
    }).join(', ');
  }

  get serviceOptionName() {
    const config = this.getServiceConfig(this.quizData.service);
    return config?.title || '';
  }

  get totalProductPrice() {
    return this.formatPrice(this.quizData.productVariant.price);
  }

  get subtotalProductPrice() {
    if (this.quizData.productVariant?.selling_plan_price) {
      return this.formatPrice(this.quizData.productVariant.selling_plan_price);
    }
    return this.formatPrice(this.quizData.productVariant.price / 2);
  }

  get productUrlWithVariant() {
    const url = this.quizData.product?.url;
    if (!url) return '';
    const variantId = this.quizData.productVariant?.id;
    if (variantId) {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}variant=${variantId}`;
    }
    return url;
  }

  get sellingPlanDiscountPercentage() {
    const variant = this.quizData.productVariant;
    if (variant?.selling_plan_percentage != null) {
      return variant.selling_plan_percentage;
    }
    if (variant?.selling_plan_discount_percentage != null) {
      return variant.selling_plan_discount_percentage;
    }
    const productPlan = this.quizData.product?.selling_plan;
    if (productPlan?.percentage != null) {
      return productPlan.percentage;
    }
    if (productPlan?.discount_percentage != null) {
      return productPlan.discount_percentage;
    }
    return null;
  }

  get sellingPlanName() {
    return this.quizData.productVariant?.selling_plan_name || this.quizData.product?.selling_plan?.name || '';
  }

  get sellingPlanDiscountAmount() {
    const variant = this.quizData.productVariant;
    if (variant?.selling_plan_discount_amount != null) {
      return this.formatPrice(variant.selling_plan_discount_amount);
    }
    return '';
  }

  get product() {
    if (this.isConsultation) return null;

    if (this.quizData.service === 'heat-pump') {
      return this.getProduct(this.quizData.system);
    }
    if (this.quizData.service === 'water-heater') {
      return this.getProduct(this.quizData.tankFuel);
    }
    if (this.quizData.service === 'ev-charger') {
      return this.getProduct('ev-charger');
    }
    return null;
  }

  get productVariant() {
    const product = this.product;
    if (!product) return null;

    if (this.quizData.service === 'heat-pump') {
      return this.getProductVariant(product, this.quizData.rooms);
    }
    if (this.quizData.service === 'water-heater') {
      return this.getProductVariant(product, this.quizData.tankSize);
    }
    if (this.quizData.service === 'ev-charger') {
      return this.getProductVariant(product, 'ev-charger');
    }
    return null;
  }

  get isConsultation() {
    const config = this.getServiceConfig(this.quizData.service);
    if (!config) return true;
    if (config.outcome_type === 'lead_capture') return true;

    if (this.quizData.service === 'heat-pump') {
      if (this.quizData.ductType === 'duct-system') return true;
      if (['more-than-4-rooms', 'whole-house'].includes(this.quizData.rooms)) return true;
      if (this.quizData.rooms === '4-rooms' && this.quizData.system === 'mitsubishi') return true;
    }
    if (this.quizData.service === 'water-heater') {
      if (this.quizData.tankType === 'tankless') return true;
      if (this.quizData.tankSize === 'other') return true;
    }
    return false;
  }

  // ==================== Lifecycle Methods ====================

  async init() {
    console.log('Greensavers Quiz Initialized', this);
    this.applyServiceFromUrl();
    this.initListeners();
    this.initRoomTypeOptions();
    this.initAddressAutocomplete();
    this.restoreFormInputs();
    this.setRandomActiveImage();
    this.render();
  }

  /**
   * If the URL has ?service=<slug> for a known service, prefill quizData.service
   * so the user skips the service-selection step (step 2) when they continue
   * past the address/property step. Used when arriving from a gated product page.
   */
  applyServiceFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const service = params.get('service');
      const known = ['ev-charger', 'water-heater', 'heat-pump'];
      if (service && known.includes(service) && this.quizData.service !== service) {
        this.updateQuizData({ service });
      }
    } catch (error) {
      console.error('Failed to read service from URL:', error);
    }
  }

  // ==================== State Management ====================

  loadQuizData() {
    try {
      const savedData = localStorage.getItem(this.STORAGE_KEY);
      return savedData ? JSON.parse(savedData) : null;
    } catch (error) {
      console.error('Failed to load quiz data:', error);
      return null;
    }
  }

  saveQuizData() {
    try {
      this.quizData.lastModified = new Date().toISOString();
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.quizData));
    } catch (error) {
      console.error('Failed to save quiz data:', error);
    }
  }

  clearQuizData() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear quiz data:', error);
    }
  }

  /**
   * Set localStorage flag so the matching gated product template unlocks.
   * Maps the quiz service slug to the localStorage key used by the template JS.
   * @param {string} serviceSlug
   */
  markQuizPathCompleted(serviceSlug) {
    const flagMap = {
      'ev-charger': 'quiz_complete_ev_charger',
      'water-heater': 'quiz_complete_water_heater',
      'heat-pump': 'quiz_complete_heat_pump',
    };
    const flag = flagMap[/** @type {keyof typeof flagMap} */ (serviceSlug)];
    if (!flag) return;
    try {
      localStorage.setItem(flag, 'true');
    } catch (error) {
      console.error('Failed to set quiz completion flag:', error);
    }
  }

  /**
   * @param {Partial<typeof this.defaultQuizData> & Record<string, any>} updates
   */
  updateQuizData(updates) {
    this.quizData = { ...this.quizData, ...updates };
    this.saveQuizData();
  }

  restoreFormInputs() {
    this.textInputElements.forEach(input => {
      const inputElement = /** @type {HTMLInputElement} */ (input);
      inputElement.value = this.quizData[inputElement.name] || '';
    });

    this.inputOptions.forEach(option => {
      const inputOption = /** @type {HTMLInputElement} */ (option);
      inputOption.checked = this.quizData[inputOption.name] || false;
    });
  }

  /**
   * Set a random image as active
   */
  setRandomActiveImage() {
    if (this.quizImages.length === 0) {
      this.quizImagesContainer?.remove();
      return;
    };
    
    // Remove is-active class from all images
    this.quizImages.forEach(image => {
      image.classList.remove('is-active');
    });
    
    // Pick a random image and add is-active class
    const randomIndex = Math.floor(Math.random() * this.quizImages.length);
    const randomImage = this.quizImages[randomIndex];
    if (randomImage) {
      randomImage.classList.add('is-active');
    }
  }

  /**
   * @param {number} stepNumber
   */
  goToStep(stepNumber) {
    // Add current step to history if moving forward
    if (stepNumber > this.quizData.currentStep) {
      this.quizData.stepHistory.push(stepNumber);
    }

    this.updateQuizData({ currentStep: stepNumber });

    // Mark quiz path as completed for gated product templates
    if (stepNumber === 99) {
      this.markQuizPathCompleted(this.quizData.service);
    }

    // Handle lead creation/update silently via Workato webhook
    if (stepNumber === 2 && !this.quizData.leadSubmitted) {
      this.submitLeadToWebhook();
    } else if (stepNumber > 2 && this.quizData.leadSubmitted) {
      this.updateLeadViaWebhook();
    }
    // --- Cloud function lead logic (commented out) ---
    // if (stepNumber === 2 && !this.quizData.leadId) {
    //   this.createInsightlyLead();
    // } else if (stepNumber > 2 && this.quizData.leadId) {
    //   this.updateInsightlyLead();
    // }
    
    this.setRandomActiveImage();
    this.render();
  }

  goBack() {
    // From the confirm-property sub-state of step 1, "back" returns to the
    // address entry view rather than popping a step off history.
    if (this.quizData.currentStep === 1 && this.quizData.confirmPropertyInformation) {
      this.updateQuizData({ confirmPropertyInformation: false });
      this.render();
      return;
    }

    // Remove current step from history
    if (this.quizData.stepHistory.length > 1) {
      this.quizData.stepHistory.pop();
      const previousStep = this.quizData.stepHistory[this.quizData.stepHistory.length - 1];
      this.updateQuizData({
        currentStep: previousStep,
        stepHistory: this.quizData.stepHistory
      });
      this.setRandomActiveImage();
      this.render();
    }
  }

  resetQuiz() {
    this.clearQuizData();
    this.quizData = { ...this.defaultQuizData };
    
    // Reset form inputs
    this.textInputElements.forEach(input => {
      const inputElement = /** @type {HTMLInputElement} */ (input);
      inputElement.value = '';
    });

    this.inputOptions.forEach(option => {
      const inputOption = /** @type {HTMLInputElement} */ (option);
      inputOption.checked = false;
    });

    // Preserve service if it's in the URL — the user arrived from a gated
    // product page and should stay on that service path after starting over.
    this.applyServiceFromUrl();

    this.setRandomActiveImage();
    this.render();
  }

  initListeners() {
    // Input options
    this.inputOptions.forEach(option => {
      option.addEventListener('change', this.handleInputOptionChange.bind(this));
    });

    this.textInputElements.forEach(input => {
      input.addEventListener('input', this.handleTextInputInputChange.bind(this));
    });

    // Back buttons
    this.backButtons.forEach(button => {
      button.addEventListener('click', this.goBack.bind(this));
    });

    // Start over buttons
    this.startOverButtons.forEach(button => {
      button.addEventListener('click', this.resetQuiz.bind(this));
    });

    // continue buttons
    this.continueButtons.forEach(button => {
      button.addEventListener('click', this.handleContinueButtonClick.bind(this));
    });

    // step 1
    if (this.findPropertyButton) {
      this.findPropertyButton.addEventListener('click', this.handleFindPropertyButtonClick.bind(this));
    }
    if (this.confirmPropertyInformationButton) {
      this.confirmPropertyInformationButton.addEventListener('click', this.handleConfirmPropertyInformationButtonClick.bind(this));
    }
    if (this.editPropertyInformationButton) {
      this.editPropertyInformationButton.addEventListener('click', this.handleEditPropertyInformationClick.bind(this));
    }
    if (this.savePropertyInformationButton) {
      this.savePropertyInformationButton.addEventListener('click', this.handleSavePropertyInformationClick.bind(this));
    }
    if (this.cancelEditPropertyButton) {
      this.cancelEditPropertyButton.addEventListener('click', this.handleCancelEditPropertyClick.bind(this));
    }
    this.editHeatingButtons.forEach(button => {
      button.addEventListener('click', this.handleEditPropertyInformationClick.bind(this));
    });
    this.editCoolingButtons.forEach(button => {
      button.addEventListener('click', this.handleEditPropertyInformationClick.bind(this));
    });

    // other
    this.consultationOptions.forEach(option => {
      option.addEventListener('click', this.handleGoToConsultationButtonClick.bind(this));
    });

    // Cart form submit validation & Add-to-cart click handler
    if (this.quizCartForm) {
      this.quizCartForm.addEventListener('submit', this.handleCartFormSubmit.bind(this));
    }
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.handleAddToCartButtonClick.bind(this));
    }
  }

  /**
   * Handle add-to-cart button click: if Down Payment plan is missing, redirect to product/variant page
   * @param {MouseEvent} event
   */
  handleAddToCartButtonClick(event) {
    const sellingPlanId = /** @type {HTMLInputElement | null} */ (this.productSellingPlanIdInput)?.value;
    if (!sellingPlanId) {
      event.preventDefault();
      event.stopPropagation();
      const productUrl = this.productUrlWithVariant;
      if (productUrl) {
        window.location.href = productUrl;
      }
    }
  }

  /**
   * Handle cart form submission: ensure Down Payment selling plan is attached, or redirect to product
   * @param {SubmitEvent} event
   */
  handleCartFormSubmit(event) {
    const sellingPlanId = /** @type {HTMLInputElement | null} */ (this.productSellingPlanIdInput)?.value;
    if (!sellingPlanId) {
      event.preventDefault();
      const productUrl = this.productUrlWithVariant;
      if (productUrl) {
        window.location.href = productUrl;
      }
      return false;
    }
  }

  /**
   * Initialize room type dropdown options
   */
  initRoomTypeOptions() {
    this.roomTypeSelects.forEach((select, index) => {
      const selectElement = /** @type {HTMLSelectElement} */ (select);
      
      // Populate dropdown options
      const fragment = document.createDocumentFragment();
      this.roomTypeOptions.forEach((option) => {
        const optionElement = document.createElement('option');
        optionElement.value = option.id;
        optionElement.textContent = option.name;
        fragment.appendChild(optionElement);
      });
      selectElement.appendChild(fragment);

      // Set initial value from saved data
      const roomKey = `room-${index + 1}`;
      selectElement.value = this.quizData.roomTypes[roomKey] || (this.roomTypeOptions[0]?.id || '');
      
      // Add change listener
      selectElement.addEventListener('change', this.handleRoomTypeSelectChange.bind(this));
    });
  }

  // ==================== Address Autocomplete ====================

  initAddressAutocomplete() {
    if (!this.MAPBOX_TOKEN) {
      console.warn('Mapbox token missing');
      return;
    }

    this.mapboxSessionToken = this.generateSessionToken();

    const input = document.getElementById('property-address-field');
    if (!input) return;

    const inputGroup = input.closest('.gs-input__group');
    if (!inputGroup) return;

    inputGroup.classList.add('gs-autocomplete');

    const spinner = document.createElement('span');
    spinner.className = 'gs-autocomplete__spinner';
    inputGroup.appendChild(spinner);
    this.autocompleteSpinner = spinner;

    const panel = document.createElement('div');
    panel.className = 'gs-autocomplete__panel';
    panel.innerHTML = '<ul class="gs-autocomplete__list" role="listbox"></ul>';
    inputGroup.appendChild(panel);
    this.autocompletePanel = panel;

    input.setAttribute('role', 'combobox');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', this.handleAutocompleteInput.bind(this));
    input.addEventListener('keydown', this.handleAutocompleteKeydown.bind(this));
    document.addEventListener('click', (e) => {
      if (!inputGroup.contains(/** @type {Node} */ (e.target))) {
        this.closeAutocomplete();
      }
    });
  }

  /**
   * @param {Event} event
   */
  handleAutocompleteInput(event) {
    const isRealInput = event instanceof InputEvent && !!event.inputType;

    if (isRealInput) {
      this.autocompleteSelected = false;
    }

    if (this.autocompleteSelected) return;

    const query = /** @type {HTMLInputElement} */ (event.target).value.trim();

    if (this.autocompleteDebounceTimer) {
      clearTimeout(this.autocompleteDebounceTimer);
    }

    if (query.length < 3) {
      this.closeAutocomplete();
      return;
    }

    this.autocompleteDebounceTimer = setTimeout(() => {
      this.fetchAutocompleteSuggestions(query);
    }, 250);
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleAutocompleteKeydown(event) {
    if (!this.autocompletePanel?.classList.contains('is-open')) return;

    const items = this.autocompletePanel.querySelectorAll('.gs-autocomplete__item');
    if (items.length === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.autocompleteActiveIndex = Math.min(this.autocompleteActiveIndex + 1, items.length - 1);
      this.updateAutocompleteActiveItem(items);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.autocompleteActiveIndex = Math.max(this.autocompleteActiveIndex - 1, 0);
      this.updateAutocompleteActiveItem(items);
    } else if (event.key === 'Enter' && this.autocompleteActiveIndex >= 0) {
      event.preventDefault();
      /** @type {HTMLElement} */ (items[this.autocompleteActiveIndex]).click();
    } else if (event.key === 'Escape') {
      this.closeAutocomplete();
    }
  }

  /**
   * @param {NodeListOf<Element>} items
   */
  updateAutocompleteActiveItem(items) {
    items.forEach((item, i) => {
      item.classList.toggle('is-active', i === this.autocompleteActiveIndex);
    });
  }

  /**
   * @param {string} query
   */
  async fetchAutocompleteSuggestions(query) {
    if (!this.MAPBOX_TOKEN) return;

    if (!this.mapboxSessionToken) {
      this.mapboxSessionToken = this.generateSessionToken();
    }

    const params = new URLSearchParams({
      access_token: this.MAPBOX_TOKEN,
      session_token: this.mapboxSessionToken,
      country: 'us',
      language: 'en',
      types: 'address',
      streets: 'true',
      proximity: 'ip',
      limit: '6',
    });

    this.showAutocompleteSpinner();
    try {
      const res = await fetch(`${this.MAPBOX_SEARCH_BASE}/suggest/${encodeURIComponent(query)}?${params.toString()}`);
      if (!res.ok) throw new Error(`Mapbox suggest failed: ${res.status}`);
      const data = await res.json();
      this.renderAutocompleteSuggestions(data.suggestions || []);
    } catch (err) {
      console.error('Mapbox search error:', err);
      this.closeAutocomplete();
    } finally {
      this.hideAutocompleteSpinner();
    }
  }

  generateSessionToken() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    // RFC4122-ish fallback
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  showAutocompleteSpinner() {
    if (this.autocompleteSpinner) {
      this.autocompleteSpinner.classList.add('is-visible');
    }
  }

  hideAutocompleteSpinner() {
    if (this.autocompleteSpinner) {
      this.autocompleteSpinner.classList.remove('is-visible');
    }
  }

  /**
   * @param {Array<any>} results
   */
  renderAutocompleteSuggestions(results) {
    if (!this.autocompletePanel) return;

    const list = this.autocompletePanel.querySelector('.gs-autocomplete__list');
    if (!list) return;

    this.autocompleteActiveIndex = -1;

    if (results.length === 0) {
      list.innerHTML = '<li class="gs-autocomplete__empty">No addresses found</li>';
      this.autocompletePanel.classList.add('is-open');
      const input = document.getElementById('property-address-field');
      if (input) input.setAttribute('aria-expanded', 'true');
      return;
    }

    const pinSvg = '<svg class="gs-autocomplete__item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>';

    list.innerHTML = results.map((item, index) => {
      const name = item.feature_name || item.address_line1 || item.address || item.name || '';
      const detail = item.description || item.place_formatted || '';
      return `
        <li class="gs-autocomplete__item" role="option" data-index="${index}">
          ${pinSvg}
          <span class="gs-autocomplete__item-text">
            <span class="gs-autocomplete__item-name">${this.escapeHtml(name)}</span>
            ${detail ? `<span class="gs-autocomplete__item-detail">${this.escapeHtml(detail)}</span>` : ''}
          </span>
        </li>
      `;
    }).join('');

    list.querySelectorAll('.gs-autocomplete__item').forEach((item) => {
      item.addEventListener('click', () => {
        const idx = parseInt(/** @type {HTMLElement} */ (item).dataset.index || '0', 10);
        this.selectAutocompleteSuggestion(results[idx]);
      });
    });

    this.autocompletePanel.classList.add('is-open');
    const input = document.getElementById('property-address-field');
    if (input) input.setAttribute('aria-expanded', 'true');
  }

  /**
   * @param {any} item
   */
  async selectAutocompleteSuggestion(item) {
    this.autocompleteSelected = true;

    const input = /** @type {HTMLInputElement | null} */ (document.getElementById('property-address-field'));
    const fallback = item.place_name
      || item.full_address
      || [item.feature_name, item.description].filter(Boolean).join(', ')
      || [item.name, item.place_formatted].filter(Boolean).join(', ');

    if (input && fallback) {
      input.value = fallback;
    }

    this.closeAutocomplete();

    const actionId = item.action?.id;
    if (actionId && this.MAPBOX_TOKEN) {
      try {
        const params = new URLSearchParams({
          access_token: this.MAPBOX_TOKEN,
          session_token: this.mapboxSessionToken || this.generateSessionToken(),
        });
        const res = await fetch(`${this.MAPBOX_SEARCH_BASE}/retrieve/${encodeURIComponent(actionId)}?${params.toString()}`);
        if (res.ok) {
          const data = await res.json();
          const feature = data.features?.[0];
          const props = feature?.properties || {};
          const fullAddress = props.place_name
            || props.full_address
            || [props.feature_name, props.description].filter(Boolean).join(', ')
            || fallback;
          if (input && fullAddress) {
            input.value = fullAddress;
          }
        }
      } catch (err) {
        console.error('Mapbox retrieve error:', err);
      }
    }

    // End session — next keystrokes start a fresh billing session
    this.mapboxSessionToken = null;

    if (input) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  closeAutocomplete() {
    if (this.autocompletePanel) {
      this.autocompletePanel.classList.remove('is-open');
    }
    this.autocompleteActiveIndex = -1;
    const input = document.getElementById('property-address-field');
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  /**
   * @param {string} str
   * @returns {string}
   */
  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /**
   * @param {{ currentTarget: { id: any; dataset: { consultationOption: string; }; }; }} event
   */
  handleGoToConsultationButtonClick(event) {
    this.updateQuizData({ 
      [event.currentTarget.dataset.consultationOption]: event.currentTarget.id 
    });

    this.goToStep(98);
  }

  handleFindPropertyButtonClick() {
    // Clear previous errors
    this.clearFieldErrors();

    // Validate all required fields
    const validationErrors = this.validateRequiredFields();
    
    if (validationErrors.length > 0) {
      // Show errors for each invalid field
      validationErrors.forEach(error => {
        this.showFieldError(error.fieldId, error.message);
      });
      return;
    }

    const address = this.quizData.propertyAddress;

    if (!address || address.trim() === '') {
      this.showFieldError('property-address-field', 'Please enter a property address');
      return;
    }

    // Show loader
    const findingText = window.gsQuizTranslations?.finding_property || 'Finding your property information';
    const prepText = window.gsQuizTranslations?.preparing_recommendations || 'Preparing recommendations...';
    this.showLoader(findingText, prepText);
    const button = /** @type {HTMLButtonElement} */ (this.findPropertyButton);
    if (button) {
      button.disabled = true;
    }

    fetch(`${this.API_URLS.propertyInfo}?address=${encodeURIComponent(address)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch property information');
        }
        return response.json();
      })
      .then(data => {
        if (data && data.length > 0) {
          this.updateQuizData({
            propertyInformation: data[0],
            confirmPropertyInformation: true
          });
          this.render();
        } else {
          throw new Error('No property found at this address');
        }
      })
      .catch(error => {
        console.error('Error fetching property:', error);
        const notFoundText = window.gsQuizTranslations?.property_not_found || 'Unable to find property information. Please check the address and try again.';
        alert(notFoundText);
      })
      .finally(() => {
        this.hideLoader();
        if (button) {
          button.disabled = false;
        }
      });
  }

  handleConfirmPropertyInformationButtonClick() {
    this.goToStep(6);
  }

  handleEditPropertyInformationClick() {
    const info = this.quizData.propertyInformation || {};

    const fieldMap = {
      formattedAddress: info.formattedAddress || '',
      propertyType: info.propertyType || '',
      bedrooms: info.bedrooms ?? '',
      bathrooms: info.bathrooms ?? '',
      squareFootage: info.squareFootage ?? '',
      yearBuilt: info.yearBuilt ?? '',
      heatingType: info.features?.heatingType || '',
      coolingType: info.features?.coolingType || '',
    };

    Object.entries(fieldMap).forEach(([field, value]) => {
      const input = /** @type {HTMLInputElement | null} */ (
        document.querySelector(`[data-edit-field="${field}"]`)
      );
      if (input) input.value = String(value);
    });

    if (this.confirmPropertyInformation) {
      this.confirmPropertyInformation.classList.add('hidden');
    }
    if (this.editPropertyInformationSection) {
      this.editPropertyInformationSection.classList.remove('hidden');
    }
  }

  handleSavePropertyInformationClick() {
    const info = { ...this.quizData.propertyInformation };

    const getValue = (/** @type {string} */ field) => {
      const input = /** @type {HTMLInputElement | null} */ (
        document.querySelector(`[data-edit-field="${field}"]`)
      );
      return input ? input.value : '';
    };

    info.formattedAddress = getValue('formattedAddress');
    info.propertyType = getValue('propertyType');
    info.bedrooms = getValue('bedrooms') ? Number(getValue('bedrooms')) : null;
    info.bathrooms = getValue('bathrooms') ? Number(getValue('bathrooms')) : null;
    info.squareFootage = getValue('squareFootage') ? Number(getValue('squareFootage')) : null;
    info.yearBuilt = getValue('yearBuilt') ? Number(getValue('yearBuilt')) : null;

    if (!info.features) info.features = {};
    info.features.heatingType = getValue('heatingType');
    info.features.heating = !!getValue('heatingType');
    info.features.coolingType = getValue('coolingType');
    info.features.cooling = !!getValue('coolingType');

    this.updateQuizData({ propertyInformation: info });
    this.renderPropertyInformation();

    if (this.editPropertyInformationSection) {
      this.editPropertyInformationSection.classList.add('hidden');
    }
    if (this.confirmPropertyInformation) {
      this.confirmPropertyInformation.classList.remove('hidden');
    }
  }

  handleCancelEditPropertyClick() {
    if (this.editPropertyInformationSection) {
      this.editPropertyInformationSection.classList.add('hidden');
    }
    if (this.confirmPropertyInformation) {
      this.confirmPropertyInformation.classList.remove('hidden');
    }
  }

  /**
   * @param {{ currentTarget: { name: any; value: any; }; }} event
   */
  handleInputOptionChange(event) {
    this.updateQuizData({ 
      [event.currentTarget.name]: event.currentTarget.value
    });

    this.render();
  }

  /**
   * @param {{ currentTarget: any; }} event
   */
  handleTextInputInputChange(event) {
    this.updateQuizData({ 
      [event.currentTarget.name]: event.currentTarget.value
    });

    // Clear error for this field when user starts typing
    const inputElement = /** @type {HTMLInputElement} */ (event.currentTarget);
    if (inputElement.classList.contains('gs-input--error')) {
      inputElement.classList.remove('gs-input--error');
      const inputGroup = inputElement.closest('.gs-input__group');
      if (inputGroup) {
        const errorElement = inputGroup.querySelector('.gs-input__error');
        if (errorElement) {
          errorElement.remove();
        }
      }
    }

    this.render();
  }

  handleContinueButtonClick() {
    if (this.quizData.currentStep === 6 && !this.quizData.service) {
      this.goToStep(2);
      return;
    }

    if (this.isConsultation) {
      this.goToStep(98);
      return;
    }

    const config = this.getServiceConfig(this.quizData.service);
    if (!config) return;

    const steps = config.steps || [];
    const idx = steps.indexOf(this.quizData.currentStep);

    if (idx === -1) {
      const firstStep = steps[0];
      this.goToStep(firstStep != null ? firstStep : (config.outcome_type === 'lead_capture' ? 98 : 99));
      return;
    }

    if (idx === steps.length - 1) {
      if (config.outcome_type === 'redirect') {
        const products = config.products || {};
        const firstProduct = Object.values(products)[0];
        if (firstProduct?.url) {
          this.updateLeadViaWebhook().finally(() => {
            window.location.href = firstProduct.url;
          });
          return;
        }
      }
      this.goToStep(config.outcome_type === 'lead_capture' ? 98 : 99);
      return;
    }
    this.goToStep(/** @type {number} */ (steps[idx + 1]));
  }

  /**
   * @param {{ currentTarget: { id: string; value: any; }; }} event
   */
  handleRoomTypeSelectChange(event) {
    const id = event.currentTarget.id.split('-')[1];
    const updatedRoomTypes = { ...this.quizData.roomTypes };
    updatedRoomTypes[`room-${id}`] = event.currentTarget.value;
    
    this.updateQuizData({ roomTypes: updatedRoomTypes });
  }

  /**
   * Update progress bar based on current step
   */
  updateProgressBar() {
    const progressMap = {
      1: 12.5,
      6: 25,
      2: 37.5,
      3: 50,
      4: 62.5,
      5: 75,
      98: 100,
      99: 100
    };

    const currentStep = this.quizData.currentStep;
    const progress = progressMap[/** @type {1 | 2 | 3 | 4 | 5 | 6 | 98 | 99} */ (currentStep)] || 0;
    
    this.quizProgressBars.forEach(bar => {
      const barElement = /** @type {HTMLElement} */ (bar);
      barElement.style.width = `${progress}%`;
    });
  }

  renderPropertyInformation() {
    if (!this.quizData.propertyInformation) return;

    const { propertyInformation } = this.quizData;
    
    this.propertyAddressElement.forEach(element => {
      element.textContent = propertyInformation.formattedAddress;
    });
    
    this.propertyInformationElement.forEach(element => {
      const items = [];

      if (propertyInformation.propertyType) {
        items.push(`${propertyInformation.propertyType} home`);
      }
      if (propertyInformation.bedrooms) {
        items.push(`${propertyInformation.bedrooms} Bedrooms`);
      }
      if (propertyInformation.bathrooms) {
        items.push(`${propertyInformation.bathrooms} Bathrooms`);
      }
      if (propertyInformation.squareFootage) {
        items.push(`${propertyInformation.squareFootage} sq ft`);
      }
      if (propertyInformation.yearBuilt) {
        items.push(`Built in ${propertyInformation.yearBuilt}`);
      }

      element.innerHTML = items.map(item => `<li>${item}</li>`).join('');
    });
    
    const notAvail = window.gsQuizTranslations?.not_available || 'Data not available';
    const heatingType = propertyInformation.features?.heatingType;
    this.propertHeatingElement.forEach(element => {
      element.textContent = heatingType ? heatingType : notAvail;
    });
    this.editHeatingWrappers.forEach(wrapper => {
      wrapper.classList.toggle('hidden', !!heatingType);
    });

    const coolingType = propertyInformation.features?.coolingType;
    this.propertyCoolingElement.forEach(element => {
      element.textContent = coolingType ? coolingType : notAvail;
    });
    this.editCoolingWrappers.forEach(wrapper => {
      wrapper.classList.toggle('hidden', !!coolingType);
    });
  }

  renderStep1() {
    if (this.propertyInformationForm) {
      this.propertyInformationForm.classList.toggle('hidden', 
        this.quizData.confirmPropertyInformation);
    }
    if (this.confirmPropertyInformation) {
      this.confirmPropertyInformation.classList.toggle('hidden', 
        !this.quizData.confirmPropertyInformation);
    }
    if (this.editPropertyInformationSection) {
      this.editPropertyInformationSection.classList.add('hidden');
    }
  }

  renderStep4() {
    if (this.roomTypesContainer) {
      this.roomTypesContainer.classList.toggle('hidden', !this.quizData.rooms);
    }

    if (this.quizData.rooms) {
      const roomsParts = this.quizData.rooms.split('-');
      const selectedRooms = roomsParts[0] ? parseInt(roomsParts[0], 10) : 0;
      
      this.roomTypes.forEach(option => {
        const roomElement = /** @type {HTMLElement} */ (option);
        const roomSelect = roomElement.dataset.roomSelect;
        
        if (roomSelect) {
          const selectParts = roomSelect.split('-');
          const selectRooms = selectParts[0] ? parseInt(selectParts[0], 10) : 0;
          option.classList.toggle('hidden', selectRooms > selectedRooms);
        }
      });
    }
  }

  renderStep5() {
    if (this.quizData.rooms) {
      const roomsParts = this.quizData.rooms.split('-');
      if (roomsParts[0]) {
        const maxRooms = parseInt(roomsParts[0], 10);
        
        // Filter room types to only include selected room count
        /** @type {{ [key: string]: string }} */
        const filteredRoomTypes = {};
        Object.keys(this.quizData.roomTypes).forEach(room => {
          const roomParts = room.split('-');
          if (roomParts[1]) {
            const roomNumber = parseInt(roomParts[1], 10);
            if (roomNumber && roomNumber <= maxRooms) {
              filteredRoomTypes[room] = /** @type {string} */ (this.quizData.roomTypes[room]);
            }
          }
        });
        this.quizData.roomTypes = filteredRoomTypes;
      }
    }

    // Water heater: When Traditional Tank > 65 gallon is selected,
    // Electric Water Heater is not available; only Heat Pump Water Heater is allowed.
    if (this.quizData.service === 'water-heater') {
      const electricOption = /** @type {HTMLElement | null} */ (
        document.querySelector('[data-tank-fuel="electric-water-heater"]')
      );
      const is65GallonTraditional =
        this.quizData.tankType === 'traditional-tank' && this.quizData.tankSize === '65-gallon';

      if (electricOption) {
        electricOption.classList.toggle('hidden', is65GallonTraditional);
      }

      if (is65GallonTraditional && this.quizData.tankFuel === 'electric-water-heater') {
        const electricInput = /** @type {HTMLInputElement | null} */ (
          document.getElementById('tankFuel-electric-water-heater')
        );
        if (electricInput) electricInput.checked = false;
        this.updateQuizData({ tankFuel: null });
      }
    }
  }

  updateLeadEmailInputs() {
    const email = String(this.quizData.emailAddress || '');

    if (this.leadEmailPropertiesInput) {
      /** @type {HTMLInputElement} */ (this.leadEmailPropertiesInput).value = email;
    }
    if (this.leadEmailAttributesInput) {
      /** @type {HTMLInputElement} */ (this.leadEmailAttributesInput).value = email;
    }
  }

  renderStep98() {
    const serviceConfig = this.getServiceConfig(this.quizData.service);
    const product = this.product;
    const productVariant = this.productVariant;

    console.group('renderStep98 Debug');
    console.log('quizData:', JSON.parse(JSON.stringify(this.quizData)));
    console.log('serviceConfig:', serviceConfig);
    console.log('isConsultation:', this.isConsultation);
    console.log('product:', product);
    console.log('productVariant:', productVariant);
    console.groupEnd();

    if (product) {
      this.updateQuizData({ product, productVariant });
      
      if (this.productVariantIdInput) {
        /** @type {HTMLInputElement} */ (this.productVariantIdInput).value = String(productVariant.id);
      }
    }

    this.updateLeadEmailInputs();
  }

  renderStep99() {
    const serviceConfig = this.getServiceConfig(this.quizData.service);
    const product = this.product;
    const productVariant = this.productVariant;

    console.group('renderStep99 Debug');
    console.log('quizData:', JSON.parse(JSON.stringify(this.quizData)));
    console.log('serviceConfig:', serviceConfig);
    console.log('isConsultation:', this.isConsultation);
    console.log('product:', product);
    console.log('productVariant:', productVariant);
    console.log('quizConfig (full):', this.quizConfig);
    console.groupEnd();

    if (product && productVariant) {
      this.updateQuizData({ product, productVariant });
    }

    if (this.quizData.product) {
      if (this.productTitleElement) {
        this.productTitleElement.textContent = this.quizData.product.title;
      }
      const linkElement = /** @type {HTMLAnchorElement | null} */ (
        this.productTitleLinkElement ||
        (this.productTitleElement?.tagName === 'A' ? this.productTitleElement : this.productTitleElement?.closest('a'))
      );
      if (linkElement && this.quizData.product.url) {
        linkElement.href = this.quizData.product.url;
      }
      if (this.productDescriptionElement) {
        this.productDescriptionElement.textContent = this.quizData.productVariant.title;
      }
      if (this.productPriceElement) {
        this.productPriceElement.textContent = this.totalProductPrice;
      }
      if (this.subtotalValueElement) {
        this.subtotalValueElement.textContent = this.subtotalProductPrice;
      }
      if (this.dueTodayValueElement) {
        this.dueTodayValueElement.textContent = this.subtotalProductPrice;
      }
      if (this.productVariantIdInput) {
        /** @type {HTMLInputElement} */ (this.productVariantIdInput).value = String(this.quizData.productVariant.id);
      }

      // Selling plan resolution (first available plan)
      const sellingPlanId = this.quizData.productVariant?.selling_plan_id || this.quizData.product?.selling_plan?.id;
      const productUrl = this.productUrlWithVariant;
      const discountPercentage = this.sellingPlanDiscountPercentage;
      const discountAmount = this.sellingPlanDiscountAmount;

      console.log('Selling Plan Resolution:', {
        sellingPlanId,
        discountPercentage,
        discountAmount,
        variantAllocationsCount: this.quizData.productVariant?.selling_plan_allocations_count,
        variantPlanId: this.quizData.productVariant?.selling_plan_id,
        variantPlanName: this.quizData.productVariant?.selling_plan_name,
        variantDiscountPercentage: this.quizData.productVariant?.selling_plan_discount_percentage,
        variantDiscountAmount: this.quizData.productVariant?.selling_plan_discount_amount,
        productPlan: this.quizData.product?.selling_plan,
        allProductPlans: this.quizData.product?.all_selling_plans
      });

      // Update discount percentage / amount on summary page if elements exist
      if (this.dueTodayPercentageElement) {
        this.dueTodayPercentageElement.textContent = discountPercentage ? ` (${discountPercentage}%)` : '';
      }
      if (this.planDiscountValueElement) {
        this.planDiscountValueElement.textContent = discountPercentage ? `${discountPercentage}%` : '';
      }
      document.querySelectorAll('[data-plan-percentage]').forEach(el => {
        el.textContent = discountPercentage ? `${discountPercentage}%` : '';
      });
      document.querySelectorAll('[data-plan-discount-amount]').forEach(el => {
        el.textContent = discountAmount || '';
      });
      document.querySelectorAll('[data-plan-name]').forEach(el => {
        el.textContent = this.sellingPlanName || '';
      });

      if (this.productSellingPlanIdInput) {
        if (sellingPlanId) {
          /** @type {HTMLInputElement} */ (this.productSellingPlanIdInput).value = String(sellingPlanId);
          /** @type {HTMLInputElement} */ (this.productSellingPlanIdInput).disabled = false;
        } else {
          /** @type {HTMLInputElement} */ (this.productSellingPlanIdInput).value = '';
          /** @type {HTMLInputElement} */ (this.productSellingPlanIdInput).disabled = true;
        }
      }

      if (sellingPlanId) {
        // Show Pay Now (Add to cart with Down Payment)
        if (this.addToCartButton) {
          this.addToCartButton.classList.remove('hidden');
          this.addToCartButton.removeAttribute('disabled');
          this.addToCartButton.removeAttribute('title');
          this.addToCartButton.type = 'submit';
          const addToCartButtonText = /** @type {HTMLSpanElement} */ (this.addToCartButton.querySelector('.gs-button__text'));
          if (addToCartButtonText) {
            addToCartButtonText.textContent = `Pay ${this.subtotalProductPrice} Now`;
          }
        }
        if (this.goToProductButton) {
          this.goToProductButton.classList.add('hidden');
        }
      } else {
        // If Down Payment plan is missing: change button to "Go to product" with product/variant link
        if (this.goToProductButton) {
          this.goToProductButton.classList.remove('hidden');
          if (productUrl) {
            /** @type {HTMLAnchorElement} */ (this.goToProductButton).href = productUrl;
          }
          if (this.addToCartButton) {
            this.addToCartButton.classList.add('hidden');
          }
        } else if (this.addToCartButton) {
          // Fallback if goToProductButton is not present
          this.addToCartButton.classList.remove('hidden');
          this.addToCartButton.removeAttribute('disabled');
          this.addToCartButton.removeAttribute('title');
          this.addToCartButton.type = 'button';
          const addToCartButtonText = /** @type {HTMLSpanElement} */ (this.addToCartButton.querySelector('.gs-button__text'));
          if (addToCartButtonText) {
            addToCartButtonText.textContent = 'Go to product';
          }
        }
      }

      const isHeatPump = this.isHeatPumpSelected();
      const incentiveMessage = window.gsQuizTranslations?.incentives_available || 'Incentives available! $800-$1800 depending on project details.';

      if (isHeatPump) {
        // Show incentive row and populate message
        if (this.incentiveRow) {
          this.incentiveRow.style.display = '';
        }
        if (this.providerDiscountLabelElement) {
          this.providerDiscountLabelElement.textContent = incentiveMessage;
        }
        if (this.providerDiscountValueElement) {
          this.providerDiscountValueElement.textContent = '';
        }
        if (this.incentivePropertiesInput) {
          /** @type {HTMLInputElement} */ (this.incentivePropertiesInput).value = incentiveMessage;
        }
      } else {
        // Hide incentive row and clear cart property
        if (this.incentiveRow) {
          this.incentiveRow.style.display = 'none';
        }
        if (this.incentivePropertiesInput) {
          /** @type {HTMLInputElement} */ (this.incentivePropertiesInput).value = '';
        }
      }
    }

    this.updateLeadEmailInputs();
  }

  async render() {
    const { currentStep } = this.quizData;

    // Show/hide back button (visible on all steps after step 1, plus the
    // confirm-property sub-state of step 1 so users can return to address entry)
    if (this.quizBackButton) {
      const hideBack = currentStep === 1 && !this.quizData.confirmPropertyInformation;
      this.quizBackButton.classList.toggle('hidden', hideBack);
    }

    // Update progress bar
    this.updateProgressBar();

    // Render step-specific content
    if (currentStep === 1) {
      this.renderStep1();
    } else if (currentStep === 4) {
      this.renderStep4();
    } else if (currentStep === 5) {
      this.renderStep5();
    } else if (currentStep === 98) {
      this.renderStep98();
    } else if (currentStep === 99) {
      this.renderStep99();
    }

    // Render property information (common across multiple steps)
    this.renderPropertyInformation();

    // Update continue button state
    this.handleContinueButtonState();

    // Update active step
    this.stepContents.forEach(stepContent => {
      stepContent.classList.toggle('is-active', (/** @type {HTMLElement} */ (stepContent)).dataset.stepContent === this.quizData.service);
    });

    this.steps.forEach(step => {
      step.classList.toggle('is-active', step.id === `step-${currentStep}`);
    });
  }

  /**
   * Updates continue button state based on form completion
   */
  handleContinueButtonState() {
    this.continueButtons.forEach(button => {
      const buttonElement = /** @type {HTMLElement} */ (button);
      const stepId = buttonElement.dataset.continueStep;

      if (!stepId) return;

      // Determine if button should be disabled
      let isEnabled = false;

      if (stepId === 'evCharger') {
        isEnabled = !!(this.quizData.evChargerPanelLocation && 
                       this.quizData.evChargerInstallationLocation && 
                       this.quizData.evChargerPanelDistance);
      } else if (stepId === 'providers') {
        isEnabled = !!(this.quizData.providerElectricity && this.quizData.providerGas);
      } else {
        isEnabled = !!this.quizData[stepId];
      }

      this.toggleDisabledAttribute(button, isEnabled);

      // Update dynamic label if present
      const dynamicLabel = /** @type {HTMLSpanElement} */ (button.querySelector('[data-dynamic-label]'));
      if (dynamicLabel && this.quizData[stepId]) {
        const labelValue = /** @type {string} */ (this.quizData[stepId]);
        dynamicLabel.textContent = this.BUTTON_DYNAMIC_LABELS[/** @type {keyof typeof this.BUTTON_DYNAMIC_LABELS} */ (labelValue)] || '';
      }
    });
  }

  // ==================== API Methods ====================

  async submitLeadToWebhook() {
    if (this.quizData.leadSubmitted) {
      return Promise.resolve();
    }

    if (!this.quizData.emailAddress || !this.quizData.firstName) {
      return Promise.resolve();
    }

    /** @type {Record<string, any>} */
    const leadData = {
      action: 'create',
      FIRST_NAME: this.quizData.firstName,
      LAST_NAME: this.quizData.lastName || '',
      EMAIL: this.quizData.emailAddress,
      PHONE: this.quizData.phoneNumber,
      MOBILE: this.quizData.phoneNumber,
      Consent_to_Text__c: false,
      ADDRESS_STREET: this.quizData.propertyInformation?.addressLine1,
      ADDRESS_CITY: this.quizData.propertyInformation?.city,
      ADDRESS_STATE: this.quizData.propertyInformation?.state,
      ADDRESS_POSTCODE: this.quizData.propertyInformation?.zipCode,
      Square_Feet__c: this.quizData.propertyInformation?.squareFootage,
      Year_Built__c: this.quizData.propertyInformation?.yearBuilt,
      Bedrooms__c: this.quizData.propertyInformation?.bedrooms,
      Bathrooms__c: this.quizData.propertyInformation?.bathrooms,
      Creation_Method__c: 'Shopify Quiz',
      Multifamily__c: this.quizData.propertyInformation?.propertyType === 'Single Family' ? false : true,
    };

    if (this.quizData.propertyInformation?.features?.garageType) {
      leadData['Garage_Types__c'] = this.quizData.propertyInformation.features.garageType;
    }
    if (this.quizData.propertyInformation?.features?.heatingType) {
      leadData['Heating_Types__c'] = this.quizData.propertyInformation.features.heatingType;
    }
    if (this.quizData.propertyInformation?.features?.coolingType) {
      leadData['Air_Conditioning_Type__c'] = this.quizData.propertyInformation.features.coolingType;
    }
    if (this.quizData.propertyInformation?.owner?.type) {
      leadData['Owner_Type__c'] = this.quizData.propertyInformation.owner.type;
    }

    try {
      const response = await fetch(this.API_URLS.workatoWebhook, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(leadData)
      });

      if (response.ok) {
        this.updateQuizData({ leadSubmitted: true });
        console.log('Lead submitted to Workato successfully');
        return true;
      } else {
        throw new Error('Failed to submit lead to Workato');
      }
    } catch (error) {
      console.error('Error submitting lead:', error);
      return null;
    }
  }

  async updateLeadViaWebhook() {
    if (!this.quizData.leadSubmitted) {
      return Promise.resolve();
    }

    /** @type {Record<string, any>} */
    const leadData = {
      action: 'update',
      EMAIL: this.quizData.emailAddress,
    };

    if (this.quizData.providerElectricity) {
      leadData['Electricity_Utility__c'] = this.ELECTRICITY_PROVIDER_NAMES[/** @type {'pge' | 'pacific-power' | 'central-electric-co-op' | 'midstate-electric-co-op'} */ (this.quizData.providerElectricity)];
    }

    if (this.quizData.providerGas) {
      leadData['Gas_Utility__c'] = this.GAS_PROVIDER_NAMES[/** @type {'northwest-natural-gas' | 'cascade-natural-gas' | 'none'} */ (this.quizData.providerGas)];
    }

    try {
      const response = await fetch(this.API_URLS.workatoWebhook, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(leadData)
      });

      if (response.ok) {
        console.log('Lead update submitted to Workato successfully');
        return true;
      } else {
        throw new Error('Failed to submit lead update to Workato');
      }
    } catch (error) {
      console.error('Error updating lead:', error);
      return null;
    }
  }

  // --- Cloud function lead methods (commented out) ---
  // async createInsightlyLead() {
  //   if (this.quizData.leadId) {
  //     return Promise.resolve();
  //   }
  //
  //   if (!this.quizData.emailAddress || !this.quizData.fullName) {
  //     return Promise.resolve();
  //   }
  //
  //   const nameParts = this.quizData.fullName.split(' ');
  //   const leadData = {
  //     FIRST_NAME: nameParts[0] || this.quizData.fullName,
  //     LAST_NAME: nameParts.slice(1).join(' ') || this.quizData.fullName,
  //     EMAIL: this.quizData.emailAddress,
  //     PHONE: this.quizData.phoneNumber,
  //     MOBILE: this.quizData.phoneNumber,
  //     Consent_to_Text__c: false,
  //     ADDRESS_STREET: this.quizData.propertyInformation?.addressLine1,
  //     ADDRESS_CITY: this.quizData.propertyInformation?.city,
  //     ADDRESS_STATE: this.quizData.propertyInformation?.state,
  //     ADDRESS_POSTCODE: this.quizData.propertyInformation?.zipCode,
  //     Square_Feet__c: this.quizData.propertyInformation?.squareFootage,
  //     Year_Built__c: this.quizData.propertyInformation?.yearBuilt,
  //     Bedrooms__c: this.quizData.propertyInformation?.bedrooms,
  //     Bathrooms__c: this.quizData.propertyInformation?.bathrooms,
  //     Creation_Method__c: 'Shopify Quiz',
  //     Multifamily__c: this.quizData.propertyInformation?.propertyType === 'Single Family' ? false : true,
  //   };
  //
  //   if (this.quizData.propertyInformation?.features?.garageType) {
  //     leadData['Garage_Types__c'] = this.quizData.propertyInformation.features.garageType;
  //   }
  //   if (this.quizData.propertyInformation?.features?.heatingType) {
  //     leadData['Heating_Types__c'] = this.quizData.propertyInformation.features.heatingType;
  //   }
  //   if (this.quizData.propertyInformation?.features?.coolingType) {
  //     leadData['Air_Conditioning_Type__c'] = this.quizData.propertyInformation.features.coolingType;
  //   }
  //   if (this.quizData.propertyInformation?.owner?.type) {
  //     leadData['Owner_Type__c'] = this.quizData.propertyInformation.owner.type;
  //   }
  //
  //   try {
  //     const response = await fetch(this.API_URLS.createLead, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(leadData)
  //     });
  //
  //     const data = await response.json();
  //
  //     if (response.ok && data.LEAD_ID) {
  //       this.updateQuizData({ leadId: data.LEAD_ID, leadSourceId: data.LEAD_SOURCE_ID, leadStatusId: data.LEAD_STATUS_ID });
  //       console.log('Lead created successfully:', data.LEAD_ID);
  //       return data;
  //     } else {
  //       throw new Error(data.error || 'Failed to create lead');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting lead:', error);
  //     return null;
  //   }
  // }
  //
  // async updateInsightlyLead() {
  //   if (!this.quizData.leadId) {
  //     return Promise.resolve();
  //   }
  //
  //   const leadData = {
  //     LEAD_ID: this.quizData.leadId,
  //     LEAD_SOURCE_ID: this.quizData.leadSourceId,
  //     LEAD_STATUS_ID: this.quizData.leadStatusId,
  //   };
  //
  //   if (this.quizData.providerElectricity) {
  //     leadData['Electricity_Utility__c'] = this.ELECTRICITY_PROVIDER_NAMES[this.quizData.providerElectricity];
  //   }
  //
  //   if (this.quizData.providerGas) {
  //     leadData['Gas_Utility__c'] = this.GAS_PROVIDER_NAMES[this.quizData.providerGas];
  //   }
  //
  //   try {
  //     const response = await fetch(this.API_URLS.updateLead, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(leadData)
  //     });
  //
  //     const data = await response.json();
  //
  //     if (response.ok) {
  //       console.log('Lead updated successfully:', this.quizData.leadId);
  //       return data;
  //     } else {
  //       throw new Error(data.error || 'Failed to update lead');
  //     }
  //   } catch (error) {
  //     console.error('Error updating lead:', error);
  //     return null;
  //   }
  // }

  // ==================== Utility Methods ====================

  /**
   * @param {string} serviceType
   * @returns {{ service_type: string, title: string, outcome_type: string, steps: number[], products: Record<string, any> } | null}
   */
  getServiceConfig(serviceType) {
    return this.quizConfig[serviceType] || null;
  }
  
  /**
   * Validates email format
   * @param {string} email
   * @returns {boolean}
   */
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * Validates US phone number format
   * @param {string} phone
   * @returns {boolean}
   */
  isValidUSPhone(phone) {
    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, '');
    // US phone numbers should be 10 digits (or 11 with country code starting with 1)
    return cleaned.length === 10 || (cleaned.length === 11 && cleaned[0] === '1');
  }

  /**
   * Validates required fields and returns array of errors
   * @returns {Array<{fieldId: string, message: string}>}
   */
  validateRequiredFields() {
    const errors = [];

    // Validate first name
    const firstName = this.quizData.firstName;
    if (!firstName || firstName.trim() === '') {
      errors.push({
        fieldId: 'first-name',
        message: 'First name is required'
      });
    }

    // Validate last name
    const lastName = this.quizData.lastName;
    if (!lastName || lastName.trim() === '') {
      errors.push({
        fieldId: 'last-name',
        message: 'Last name is required'
      });
    }

    // Validate email
    const email = this.quizData.emailAddress;
    if (!email || email.trim() === '') {
      errors.push({
        fieldId: 'email-address',
        message: 'Email address is required'
      });
    } else if (!this.isValidEmail(email)) {
      errors.push({
        fieldId: 'email-address',
        message: 'Please enter a valid email address'
      });
    }

    // Validate phone
    const phone = this.quizData.phoneNumber;
    if (!phone || phone.trim() === '') {
      errors.push({
        fieldId: 'phone-number',
        message: 'Phone number is required'
      });
    } else if (!this.isValidUSPhone(phone)) {
      errors.push({
        fieldId: 'phone-number',
        message: 'Please enter a valid US phone number'
      });
    }

    return errors;
  }

  /**
   * Shows error message for a specific field
   * @param {string} fieldId
   * @param {string} message
   */
  showFieldError(fieldId, message) {
    const inputElement = document.getElementById(fieldId);
    if (!inputElement) return;

    const inputGroup = inputElement.closest('.gs-input__group');
    if (!inputGroup) return;

    // Add error class to input
    inputElement.classList.add('gs-input--error');

    // Remove existing error message if any
    const existingError = inputGroup.querySelector('.gs-input__error');
    if (existingError) {
      existingError.remove();
    }

    // Create and add error message
    const errorElement = document.createElement('span');
    errorElement.className = 'gs-input__error';
    errorElement.textContent = message;
    inputGroup.appendChild(errorElement);
  }

  /**
   * Clears all field errors
   */
  clearFieldErrors() {
    // Remove error classes from all inputs
    const errorInputs = document.querySelectorAll('.gs-input--error');
    errorInputs.forEach(input => {
      input.classList.remove('gs-input--error');
    });

    // Remove all error messages
    const errorMessages = document.querySelectorAll('.gs-input__error');
    errorMessages.forEach(error => {
      error.remove();
    });
  }

  /**
   * @param {number} priceInCents
   * @returns {string}
   */
  /**
   * Check if any heat pump system is selected.
   * If any heat pump is selected, incentives are available regardless of other conditions.
   * @returns {boolean}
   */
  isHeatPumpSelected() {
    if (this.quizData.service === 'heat-pump') return true;
    if (this.quizData.system === 'quilt' || this.quizData.system === 'mitsubishi') return true;
    if (this.quizData.tankFuel === 'heat-pump-water-heater') return true;
    const productTitle = this.quizData.product?.title || '';
    if (/heat\s*pump/i.test(productTitle)) return true;
    return false;
  }

  /**
   * Get the incentive message if any heat pump is selected.
   * @returns {string|null} The incentive message, or null if not eligible.
   */
  getIncentiveAmount() {
    return this.isHeatPumpSelected()
      ? (window.gsQuizTranslations?.incentives_available || 'Incentives available! $800-$1800 depending on project details.')
      : null;
  }

  formatPrice(priceInCents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(priceInCents / 100);
  }

  /**
   * @param {Element} element
   * @param {boolean} value
   */
  toggleDisabledAttribute(element, value) {
    if (!value) {
      element.setAttribute('disabled', '');
    } else {
      element.removeAttribute('disabled');
    }
  }


  /**
   * @param {string} productKey
   * @returns {any}
   */
  getProduct(productKey) {
    const config = this.getServiceConfig(this.quizData.service);
    return config?.products?.[productKey] || null;
  }

  /**
   * Selects the correct variant from a product by matching quiz answers
   * against variant option values and titles.
   * Supports word numbers (e.g. "One Indoor Unit", "Two Indoor Units", "Three Indoor Units")
   * as well as numeric values (e.g. "50-gallon", "65-gallon", "1-rooms").
   * @param {any} product
   * @param {string} matchValue - quiz answer like "2-rooms" or "50-gallon"
   * @returns {any}
   */
  getProductVariant(product, matchValue) {
    if (!product?.variants?.length) return null;
    if (product.variants.length === 1) return product.variants[0];
    if (!matchValue) return product.variants[0];

    const numericKey = String(matchValue).split('-')[0].toLowerCase();

    /** @type {Record<string, string[]>} */
    const numToWords = {
      '1': ['one'],
      '2': ['two'],
      '3': ['three'],
      '4': ['four'],
    };

    const targetWords = numToWords[numericKey] || [];

    /**
     * @param {any} variant
     * @returns {string[]}
     */
    const getVariantStrings = (variant) => {
      const strings = [];
      if (variant.title) strings.push(String(variant.title).toLowerCase());
      if (variant.option1) strings.push(String(variant.option1).toLowerCase());
      if (variant.option2) strings.push(String(variant.option2).toLowerCase());
      if (variant.option3) strings.push(String(variant.option3).toLowerCase());
      if (Array.isArray(variant.options)) {
        variant.options.forEach((/** @type {any} */ opt) => {
          if (opt) strings.push(String(opt).toLowerCase());
        });
      }
      return strings;
    };

    // 1. First priority: match word boundary for words like "one", "two", "three"
    // e.g. "One Indoor Unit", "Two Indoor Units", "Three Indoor Units"
    if (targetWords.length > 0) {
      const wordMatch = product.variants.find((/** @type {any} */ v) => {
        const textValues = getVariantStrings(v);
        return textValues.some(text =>
          targetWords.some(word => new RegExp(`\\b${word}\\b`, 'i').test(text))
        );
      });
      if (wordMatch) return wordMatch;
    }

    // 2. Second priority: match digits / prefixes (e.g., "50-gallon" -> "50 Gallon" or "1 Unit")
    const numericMatch = product.variants.find((/** @type {any} */ v) => {
      const textValues = getVariantStrings(v);
      return textValues.some(text =>
        text.startsWith(numericKey) || new RegExp(`\\b${numericKey}\\b`).test(text)
      );
    });
    if (numericMatch) return numericMatch;

    return product.variants[0];
  }

  /**
   * Show loader with custom title and description
   * @param {string} title - The title to display in the loader
   * @param {string} description - The description to display in the loader
   */
  showLoader(title, description) {
    if (this.loaderText) {
      this.loaderText.textContent = title;
    }
    if (this.loaderDescription) {
      this.loaderDescription.textContent = description;
    }
    if (this.loader) {
      this.loader.classList.add('is-active');
    }
  }

  /**
   * Hide the loader
   */
  hideLoader() {
    if (this.loader) {
      this.loader.classList.remove('is-active');
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  new GreensaversQuiz().init();
});
